import { visibleWhoDrugFilterOptions } from "../hooks/useWhoDrugFilterOptions";
import { Combobox, ComboboxInput, ComboboxContent, ComboboxItem, ComboboxEmpty } from "@/components/ui/combobox";
import type { WhoDrugFilterOption } from "@/lib/api/generated/casedb";

type Props = {
  label: string;
  placeholder: string;
  value: string;
  options: WhoDrugFilterOption[];
  disabled: boolean;
  onChange: (value: string) => void;
};

export function WhoDrugFilterDropdown({ label, placeholder, value, options, disabled, onChange }: Props) {
  return <div className="min-w-0 space-y-1">
    <div className="text-sm font-medium">{label}</div>
    <Combobox filterItems={visibleWhoDrugFilterOptions} value={value || null} onValueChange={selected => onChange(selected ?? "")}>
      <ComboboxInput aria-label={`WHODrug ${label === "Country" ? "country" : "MAH"} filter`}
        placeholder={placeholder} disabled={disabled} className="pr-9" />
      <ComboboxContent>
        {options.map(option => <ComboboxItem key={option.value} value={option.value!}
          label={`${option.label} (${option.value})`} />)}
        <ComboboxEmpty>No matching options</ComboboxEmpty>
        <p className="px-3 py-2 text-xs text-muted-foreground">Up to 50 options shown. Type to search the full list.</p>
      </ComboboxContent>
    </Combobox>
  </div>;
}
